import { create } from "zustand";
import type { PopupStore } from "./types";

const usePopup = create<PopupStore>((set) => ({
    comps: [],
    closing: [],
    addComp: (comp) =>
        set((state) => ({
            comps: [
                ...state.comps,
                {
                    anim: "fade",
                    place: "center",
                    cover: "shaded",
                    coverClose: true,
                    ...comp,
                },
            ],
            closing: state.closing.filter((n) => n !== comp.name),
        })),
    removeComp: (name) =>
        set((state) => ({
            comps: state.comps.filter((c) => c.name !== name),
            closing: state.closing.filter((n) => n !== name),
        })),
    requestClose: (name) => set((state) => (state.closing.includes(name) ? state : { closing: [...state.closing, name] })),
}));

export default usePopup;
